export default {"src":"/_next/static/media/discountGreen_64.6de916fb.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};